import { LOADED } from "./actionTypes"

export const loadPost = (posts = []) => {
    return { type: LOADED, payload: posts }
}